/*
  Group endpoints by resource and HTTP Method
*/

const LIMIT_DEFAULT = 50;

const account = {
  get: () => `/accounts`,
  getDetail: ({ accountId }) => `/accounts/${accountId}`,
  getById: ({ accountId }) => `/accounts/${accountId}`,
  getTPLinkPlugs: ({ accountId }) => `/accounts/${accountId}/tp-link-plugs`,
  put: ({ accountId }) => `/accounts/${accountId}`,
  putSetupStep: ({ accountId }) => `/accounts/${accountId}/setup-step`,
  post: () => `/account`,
  postInvitations: ({ accountId }) => `/accounts/${accountId}/invitations`,
  getCarbonSavings: ({ accountId }) => `/accounts/${accountId}/carbon-savings`
};

const cycles = {
  get: ({ accountId, limit = LIMIT_DEFAULT }) =>
    `/accounts/${accountId}/cycles?limit=${limit}`,
  getDetail: ({ accountId, cycleId }) =>
    `/accounts/${accountId}/cycles/${cycleId}`
};

const systems = {
  get: ({ accountId }) => `/accounts/${accountId}/systems`,
  post: ({ accountId }) => `/accounts/${accountId}/system`,
  getDetail: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}`,
  getApplianceTypes: () => `/appliance-types`,
  deleteOperationalWindow: ({ accountId, systemId, operationalWindowId }) =>
    `/accounts/${accountId}/systems/${systemId}/operational-windows/${operationalWindowId}`,
  postOperationalWindow: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}/operational-window`,
  start: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}/start`,
  postGenerateRules: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}/generate-rules`
};

const devices = {
  get: ({ accountId }) => `/accounts/${accountId}/devices`,
  post: ({ accountId }) => `/accounts/${accountId}/device`
};

const auth = {
  login: () => `/login`,
  refreshToken: () => `/refresh-token`,
  register: () => `/register`
};

const rules = {
  post: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}/rule`,
  get: ({ accountId, systemId }) =>
    `/accounts/${accountId}/systems/${systemId}/rules`,
  put: ({ accountId, systemId, ruleId }) =>
    `/accounts/${accountId}/systems/${systemId}/rules/${ruleId}`,
  delete: ({ accountId, systemId, ruleId }) =>
    `/accounts/${accountId}/systems/${systemId}/rules/${ruleId}`
};

const carbonComparisons = {
  get: () => `/carbon-comparisons`
};

export { auth, account, cycles, systems, devices, rules, carbonComparisons };
